import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Permission } from '../../../../interfaces/permission.interface';
import { AppService } from '../../../../services/app.service';

@Component({
  selector: 'app-addc2u',
  templateUrl: './addc2u.component.html',
  styleUrls: ['./addc2u.component.scss']
})
export class Addc2uComponent implements OnInit {

  public custIdFormControl: FormControl = new FormControl('');
  public icodeFormControl: FormControl = new FormControl('');


  private setValidators() {
    this.custIdFormControl.setValidators([Validators.required]);

    this.icodeFormControl.setValidators([Validators.required,
      (c: AbstractControl) => {
        if (!this.icodeNotFound) {
          return null;
        } else {
          return {
            not_found: {
              valid: false
            }
          };
        }
      },
      (c: AbstractControl) => {
        if (!this.icodeConflict) {
          return null;
        } else {
          return {
            conflict: {
              valid: false
            }
          };
        }
      }]);
  }

  public icodeNotFound = false;
  public icodeConflict = false;
  public icodeFormSubscription: Subscription;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private app: AppService, private dialogRef:MatDialogRef<Addc2uComponent>) { }

  ngOnInit(): void {
    this.setValidators();
  }

  submit() {
    if(this.custIdFormControl.valid && this.icodeFormControl.valid) {
      let data = {
        external_id: this.custIdFormControl.value.trim(),
        key: this.icodeFormControl.value.trim(),
        hash: null
      };

      this.app.dialog.loader({
        title: 'Die Anforderung wird beantragt'
      });

      this.app.confirmInvitation(data).then((c2us: Permission[]) => {
        this.app.dialog.closeLoader();
        this.app.toast.open(c2us.length + (c2us.length === 1 ? ' Zugang hinzugefügt' : ' Zugänge hinzugefügt'));

        this.dialogRef.close(c2us);
      }).catch((e: HttpErrorResponse) => {
        this.app.dialog.closeLoader();
        this.handleRedemptionError(e);
      });
    }
  }

  protected async confirmInvitation(): Promise<void> {
    this.app.dialog.loader({
      title: 'Überprüfe Einladungs-Code'
    });
  }

  handleRedemptionError(e: HttpErrorResponse) {
    let msg = e.error && e.error.msg ? e.error.msg : null;

    switch ((e as HttpErrorResponse).status) {
      case 409:
        msg = msg || 'Einladungs-Code wird bereits verwendet.';
        this.icodeConflict = true;
        break;
      case 404:
        msg = msg || 'Einladungs-Code wurde nicht gefunden.';
          this.icodeNotFound = true;
        break;
      default:
        msg = msg || 'Unbekannter Fehler';
        break;
    }

      this.app.toast.open(msg, null, {
        panelClass: 'warn'
      });


    this.icodeFormSubscription = this.icodeFormControl.valueChanges.subscribe(() => {
      this.icodeConflict = this.icodeNotFound = false;
      this.icodeFormControl.markAsPristine();
      this.icodeFormSubscription.unsubscribe();
    });

    this.icodeFormControl.updateValueAndValidity();
  }
}
